import { useState, useEffect } from 'react';
import { getXsrfToken } from '../utils/xsrf';

/**
 * Lightweight hook to get the current Island user ID.
 * Fetches the Stream token but doesn't establish a Stream connection.
 * @param {boolean} enabled - Whether to fetch the user ID (default: true)
 */
const useIslandUserId = (enabled = true) => {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (!enabled) return;
    
    const fetchUserId = async () => {
      try {
        const xsrf = getXsrfToken();

        const response = await fetch('/island-api/v1/stream/token', {
          method: 'POST',
          headers: {
            'X-xsrftoken': xsrf,
            'Content-Type': 'application/json'
          },
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          setUserId(data.user_id);
        }
      } catch (e) {
        console.error('Failed to fetch user ID:', e);
      }
    };

    fetchUserId();
  }, [enabled]);

  return userId;
};

export default useIslandUserId;
